<template>
  <!-- you can remove 'clipped' if there is no app-bar -->
  <v-navigation-drawer
    v-model="drawer"
    app
    fixed
    clipped
    :mini-variant="mini"
    mini-variant-width="76"
    :class="['unselectable']"
    mobile-break-point="600"
    :temporary="temporaryNav"
    touchless>

    <div class="c-flex-c1" style="overflow: hidden; height: 100%;">

      <v-list class="pa-0">

        <v-list-item @click="clickMenu()" v-if="$vuetify.breakpoint.xs">
          <v-list-item-avatar size="36">
            <img src="@/assets/img/icons/pvlogo.png" alt="cardboard box" width="42px">
          </v-list-item-avatar>
          <v-list-item-content>
              <v-list-item-title></v-list-item-title>
              <v-spacer></v-spacer>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
        v-if="!$store.state.socketConnection">
          <v-list-item-avatar size="36">
            <v-icon color="red">power_off</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
              <v-list-item-title class="grey--text">Socket offline</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <div class="c-hr c-flex-00a"></div>

        <v-list nav style="border-radius: 0px!important;" :class="['nav-list backgroundNav', {'nav-img-background': $store.state.theme === 'theme1' && $store.state.themeDark}]" dense>

          <!-- user group deprecated, keeping to show how to expand a group-->
          <!--
          <v-list-group no-action v-model="userGroup">

            <v-list-item slot="activator">
              <v-list-item-avatar size="36">
                <v-icon>person_outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="mod-content">
                  <v-list-item-title>{{ $store.state.auth.username }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/user/profile" active-class="active-link">
              <v-list-item-avatar size="18" class="min-width-35">
                <v-icon small>person_outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>My profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="signOut">
              <v-list-item-avatar size="18" class="min-width-35">
                <v-icon small>exit_to_app</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Sign out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-group>
          -->
          <!-- user group -->

          <v-list-item 
          v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)"
          to="/test" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>code</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Test</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item 
          v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)"
          to="/developer-docs" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>code</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Developer Docs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item 
          to="/documentation" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Documentation</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/dashboard" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>mdi-view-dashboard-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)" to="/notifications" active-class="active-link">
            <v-list-item-avatar tile>
              <v-badge
              color="red"
              right
              top
              overlap
              :value="mini"
              >
                <template v-slot:badge>
                  1
                </template>
                <v-icon>mdi-bell-outline</v-icon>
              </v-badge>
            </v-list-item-avatar>
              
            <v-list-item-content class="mod-content">
                <v-list-item-title>Notifications</v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar color="red" size="24">
              <span class="white--text">1</span>
            </v-list-item-avatar>
          </v-list-item>

          <v-subheader v-if="!mini">Settings</v-subheader>

          <v-list-item to="/settings" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>mdi-settings-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/currencies" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>mdi-currency-eur</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Currencies</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="$accessControl.userHasAccess(1, $store.state.auth.accessControl)">
            
            <v-subheader v-if="!mini">Admin</v-subheader>

            <v-list-item
            v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)"
            to="/admin/server-statistics" active-class="active-link">
              <v-list-item-avatar size="36">
                <v-icon>mdi-chart-bar-stacked</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Server statistics</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/admin/users" active-class="active-link">
              <v-list-item-avatar size="36">
                <v-icon>mdi-account-group-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Users</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </template>

          <v-subheader v-if="!mini" class="mt-3">Inventory</v-subheader>

          <v-list-item to="/internal-codes" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>mdi-label</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Internal Codes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/deliveries" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>mdi-truck-delivery</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Deliveries</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item 
          v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)"
          to="/returns" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>mdi-truck-delivery</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Returns</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/inventory/inventory-definitions" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon>mdi-package-up</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Inventory</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/inventory-tx" active-class="active-link">
            <v-list-item-avatar size="36">
              <v-icon small>mdi-timeline-text-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Inventory transactions</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/samples" active-class="active-link">
            <v-list-item-avatar size="36">
              <!-- <img src="@/assets/img/illustrations/sample.png" alt="cardboard box" width="42px"> -->
              <v-icon>mdi-beaker-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>Samples</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <template v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)">

            <v-subheader v-if="!mini" class="mt-3">Forecasting</v-subheader>

            <v-list-item to="/forecast" active-class="active-link">
              <v-list-item-avatar size="36">
                <v-icon>timeline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Forecast</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

            <v-subheader v-if="!mini" class="mt-3">Production</v-subheader>

            <v-list-item to="/productions" active-class="active-link">
              <v-list-item-avatar size="36">
                <!-- <img class="header-img" src="@/assets/img/illustrations/production.png" alt="cardboard box" width="40px"> -->
                <v-icon>mdi-hammer</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Production</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-subheader v-if="!mini" class="mt-3">Suppliers</v-subheader>

            <v-list-item to="/suppliers" active-class="active-link">
              <v-list-item-avatar size="36">
                <!-- <img class="header-img" src="@/assets/img/illustrations/open.png" alt="cardboard box" width="120px"> -->
                <v-icon>mdi-home-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Suppliers</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-subheader v-if="!mini" class="mt-3">Customers</v-subheader>

            <v-list-item to="/customers" active-class="active-link">
              <v-list-item-avatar size="36">
                <v-icon>person_add</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Customers</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-subheader v-if="!mini" class="mt-3">Sales</v-subheader>

            <v-list-item to="/sales-quotes" active-class="active-link">
              <v-list-item-avatar size="36">
                <!-- <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="42px"> -->
                <v-icon>mdi-currency-usd</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Quotes</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/invoices" active-class="active-link">
              <v-list-item-avatar size="36">
                <v-icon>mdi-currency-usd</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Invoices</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/sales" active-class="active-link">
              <v-list-item-avatar size="36">
                <!-- <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="42px"> -->
                <v-icon>mdi-package-down</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Sales / Packing slips</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/price-lists" active-class="active-link">
              <v-list-item-avatar size="36">
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  <v-list-item-title>Price lists</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <template v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)">
              <v-subheader v-if="!mini" class="mt-3">Accounting</v-subheader>

              <v-list-item 
              to="/accounting" active-class="active-link">
                <v-list-item-avatar size="36">
                  <v-icon>mdi-calculator</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>Accounting</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item 
              to="/mileage" active-class="active-link">
                <v-list-item-avatar size="36">
                  <v-icon>mdi-calculator</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>Mileage</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

            </template>

        </v-list>

        <div class="c-hr c-flex-00a"></div>

        <div>

          <!-- bottom fixed area -->

        </div>

    </div>

  </v-navigation-drawer>
</template>

<script>
export default {
  data () {
    return {
      mini: true,
      userGroup: false // deprecated
    }
  },
  watch: {
    $route () {
      if (this.$vuetify.breakpoint.sm) {
        this.drawer = true
        this.mini = true
      }
    },
    '$vuetify.breakpoint': {
      immediate: true,
      handler (nv) {
        if (this.$vuetify.breakpoint.xs) {
          this.mini = false
        } else {
          this.mini = true
        }
        // console.log('breakpoint is changing')
        if (this.$vuetify.breakpoint.smAndUp) {
          this.drawer = true
        }
      }
    },
    drawer (nv) {
      if (this.$vuetify.breakpoint.smAndUp) {
        this.drawer = true
        console.log('yeap')
      }
      console.log(this.drawer)
    },
    darkMode (nv) {
      this.toggleDarkMode(nv)
    }
  },
  computed: {
    temporaryNav () {
      if (this.$vuetify.breakpoint.sm && this.drawer && !this.mini) {
        return true
      }
      return false
    },
    drawer: {
      get () {
        return this.$store.state.navMain
      },
      set (val) {
        this.$store.commit('openNavMain', val)
      }
    },
    theme () {
      return this.$store.state.theme
    }
  },
  methods: {
    clickMenu () {
      // if its in mini variant mode and screen size bigger than phone
      if (this.$vuetify.breakpoint.smAndUp) {
        this.mini = !this.mini
      } else {
        this.drawer = !this.drawer
      }
    },
    toggleDarkMode (nv) {
      this.darkMode = nv
    },
    goTo (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-content {
  flex-direction: row;
  align-items: center;
}
.nav-list {
  overflow-y: auto;
  overflow-x: hidden;
  letter-spacing: .04785714em;
  font-family: 'Open Sans',Roboto,Arial,sans-serif;
  font-weight: 600;
  font-size: .875rem;
  flex: 1;
}
.theme--light .nav-searchbar {
  margin-right: 10px;

  & ::v-deep .v-icon {
    color: #454F63;
  }
}

.theme--light.v-icon {
  color: var(--v-textNav-base)!important;
}

.v-list .v-list-item--active {
  color: var(--v-textNav-base)!important;
}

.theme--light .v-subheader {
  color: var(--v-textNav-base)!important;
  opacity: 0.8;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: var(--v-textNav-base)!important;
}

.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: var(--v-textNav-base)!important;
}

.nav-img-background {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.9) 100%), url('https://picsum.photos/1920/1080?random&blur=6');
  background-size: cover;
  background-position: center;
}
</style>
